import { Badge, Stack } from 'react-bootstrap';

import {
  DC_RESOURCE_TYPE,
  DECOMMISSIONED,
  ES_RESOURCE_TYPE,
  INSTR_RESOURCE_TYPE,
  OPEN_ACCESS,
  OPERATIONAL,
  RESTRICTED_ACCESS,
} from './constants';
import { getAccessibilityStatus } from './utils/accessibility';
import { type DOI } from './utils/doi';
import { getOperationalStatus } from './utils/operational';

export function DOITypes({ doi }: { doi: DOI }) {
  const accessibilityStatus = getAccessibilityStatus(doi);
  const operationalStatus = getOperationalStatus(doi);

  return (
    <Stack
      direction="horizontal"
      style={{
        fontSize: '1.3rem',
      }}
      gap={2}
    >
      {doi.resourceType === ES_RESOURCE_TYPE && (
        <Badge bg="secondary">Session</Badge>
      )}
      {doi.resourceType === DC_RESOURCE_TYPE && (
        <Badge bg="secondary">Data Collection</Badge>
      )}
      {doi.resourceTypeGeneral === INSTR_RESOURCE_TYPE && (
        <Badge bg="secondary">Instrument</Badge>
      )}
      {operationalStatus === OPERATIONAL && (
        <Badge bg="success">Operational</Badge>
      )}
      {operationalStatus === DECOMMISSIONED && (
        <Badge bg="dark">Decommissioned</Badge>
      )}
      {accessibilityStatus === OPEN_ACCESS && (
        <Badge bg="success">Open access</Badge>
      )}
      {accessibilityStatus === RESTRICTED_ACCESS && (
        <Badge bg="warning">Restricted access</Badge>
      )}
    </Stack>
  );
}
